import LeftContent from './leftContent'
import RightContent from './rightContent'

const Info = ({ info }) => {
  const base = 'flex flex-col lg:flex-row justify-between gap-mediumMobile lg:gap-smallDesktop mt-mediumMobile lg:mt-mediumDesktop'
  
  return (
    <div className={base}>
      <LeftContent
        title={info.title}
        instagram={info.instagram}
        email={info.email}
        whatsapp={info.whatsapp}
      />
      <RightContent
        map={info.map}
        address={info.address}
        ctaButton={info.ctaButton}
      />
    </div>
  )
}

export default Info
